/**
 * Imports the BASE URL from the config.
 */
import { FH_CONFIG } from '../config.js';

const CancelToken = axios.CancelToken;
let cancel;

export default {
    /**
     * GET /api/bookings
     */
    getBookings: function( params ){
        return axios.get(  '/api/bookings' , { params: params } );
    },

     /**
     * GET /api/bookings
     */
    getCarrierBookings: function( params ){
        return axios.get('/api/bookings' , {
            params: params,
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancel = c;
            })
        });
    },

    /**
     * GET /api/bookings/{bookingID}
     */
    getBooking: function( bookingID ){
        return axios.get( FH_CONFIG.BASE_URL + '/api/bookings' + bookingID );
    },

    /**
     * POST /api/bookings
     *
     * Not in use, demonstration only
     */
    postNewBooking: function( name, address, city, state, zip ){
        return axios.post( FH_CONFIG.BASE_URL + '/api/bookings',
            {
                name: name,
                address: address,
                city: city,
                state: state,
                zip: zip
            }
        );
    },
}